export default "__VITE_ASSET__DLhM5fJt__"